'use strict';

var MarketProductGroupKpiRibbonFilterFactory = function MarketProductGroupKpiRibbonFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupMarketFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupDowFilterFactory', 'MarketProductGroupClassGroupFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function KpiRibbonFilter() {
    DemandFilter.call(this, 'market-product-group', 'kpi-ribbon');
    this.registerFilters(injectedFilters);
  }
  KpiRibbonFilter.constructor = KpiRibbonFilter;
  KpiRibbonFilter.prototype = Object.create(DemandFilter.prototype);
  return KpiRibbonFilter;
};
MarketProductGroupKpiRibbonFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketProductGroupKpiRibbonFilterFactory;